import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authenticated: false,
  user: null,
  selected: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAuth: (state, { payload }) => {
      state.authenticated = payload;
    },
    setUser: (state, { payload }) => {
      state.user = payload;
    },
    setSelected: (state, { payload }) => {
      state.selected = payload;
    },
    clearSelected: (state) => {
      state.selected = null;
    },
    resetAppStateOnLogout: (state) => {
      state.authenticated = false;
      state.selected = null;
      state.user = null;
    },
  },
});

export const {
  resetAppStateOnLogout,
  setAuth,
  setUser,
  setSelected
} = appSlice.actions;
export default appSlice.reducer;
export const appSelector = (state) => state.app;
